import { initialState, DeclinedServicesState, declinedServicesAdapter } from './declined-services.interfaces';
import * as fromDeclinedServices from './declined-services.actions';
export function reducer(
  state = initialState,
  action: fromDeclinedServices.DeclinedServiceAction
): DeclinedServicesState {
  switch (action.type) {
    case fromDeclinedServices.ADD_DECLINED_SERVICE_IN_STATE: {
      return {
        ...declinedServicesAdapter.addOne(action.payload.serviceGroup, state)
      };
    }
    case fromDeclinedServices.REMOVE_DECLINED_SERVICE_IN_STATE: {
      return {
        ...declinedServicesAdapter.removeOne(action.payload.id, state)
      };
    }
    case fromDeclinedServices.CLEAR_DECLINED_SERVICE_IN_STATE: {
      return initialState
    }
    default: {
      return state;
    }
  }
}
